<template>
    <div class="d-flex justify-content-center mb-3">
        <ul class="nav nav-pills">
            <li class="nav-item">
                <router-link to="/call-center" class="nav-link" :class="ativo == 'call-center' ? 'active' : ''">
                    <i class="far fa-calendar-plus mr-2"></i>
                    Marcação
                </router-link>
            </li>
            <li class="nav-item">
                <router-link to="/call-center/confirmacao" class="nav-link" :class="ativo == 'confirmacao' ? 'active' : ''">
                    <i class="fas fa-user-check mr-2"></i>
                    Confirmação
                </router-link>
            </li>

            <template v-if="!$store.state.user.id_plano">
                <li class="nav-item">
                    <router-link to="/call-center/orcamento" class="nav-link" :class="ativo == 'orcamento' ? 'active' : ''">
                        <i class="fas fa-dollar-sign mr-2"></i>
                        Orçamento
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/call-center/info" class="nav-link" :class="ativo == 'info' ? 'active' : ''">
                        <i class="fas fa-book-open mr-2"></i>
                        Informações
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/call-center/bloqueio" class="nav-link" :class="ativo == 'bloqueio' ? 'active' : ''">
                        <i class="fas fa-ban mr-2"></i>
                        Bloqueio
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/call-center/listaespera" class="nav-link" :class="ativo == 'lista' ? 'active' : ''">
                        <i class="fa fa-list-ol mr-2" aria-hidden="true"></i>
                        Lista de Espera
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/call-center/mapasala" class="nav-link" :class="ativo == 'mapasala' ? 'active' : ''">
                        <i class="fas fa-map mr-2"></i>
                        Mapa de Sala
                    </router-link>
                </li>
                <li class="nav-item">
                    <div class="btn-group dropleft">
                        <button
                            class="btn btn-light dropdown-toggle"
                            type="button"
                            id="triggerId"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            >
                            <i class="fas fa-ellipsis-h ml-2"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="triggerId">
                            <router-link to="/call-center/entrega-resultado" class="dropdown-item" :class="ativo == 'entrega-resultado' ? 'active' : ''">
                                Entrega de Resultado
                            </router-link>
                            <router-link to="/call-center/valores" class="dropdown-item" :class="ativo == 'valores' ? 'active' : ''" v-if="$store.state.user.id_usuario == 1">
                                Valores Previstos
                            </router-link>
                        </div>
                    </div>
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
export default {
    props: [ 'ativo']
}
</script>